<template>
    <v-card style="border-radius: 15px">
        <v-layout
            row
            justify-center
            style="padding: 10px">
            <div
                key="relatorio_title"
                class="title pa-2 text-xs-center"
                >
            {{ strings[idioma].relatorio_financeiro_cenarios }}
            </div>
        </v-layout>
        <v-layout
            wrap>
            <v-flex 
                v-for="relatorio_financeiro_cenario, percentagem in relatorio_financeiro_cenarios"
                style="padding: 10px"
                xs12
                md4
                :key="percentagem" 
                >
            <v-card style="border-radius: 15px" flat>
                <h3>{{ strings[idioma].x_do_gmd.format(parseInt(percentagem * 100)) }}  <i>({{ (parseString(animal_.ganho_medio_diario, idioma) * parseFloat(percentagem)).toFixed(2).replace('.', strings[idioma].separador_float) }}kg)</i></h3>
                <v-data-table
                    :ref="'dTableRelatorioFinanceiro' + parseInt(percentagem * 100)"
                    :items="headersRelatorioFinanceiro"
                    item-key="id"
                    show-expand
                    hide-actions
                    hide-headers
                    class="elevation-1 table-exigencias table-relatorio"
                    >
                    <template v-slot:items="props">
                        <tr style="background-color: #ababab">
                        <td
                            style="text-align: center"
                            @click="props.expanded = !props.expanded"
                        >
                            <v-icon
                            :color="props.expanded ? 'black' : 'black'"
                            >{{
                            props.expanded
                                ? "mdi-chevron-down"
                                : "mdi-chevron-right"
                            }}</v-icon
                            >

                            <strong style="font-size: 18px">{{
                            props.item.title[idioma]
                            }}</strong>
                        </td>
                        </tr>
                    </template>
                    <template v-slot:expand="props">
                        <v-card
                        v-if="
                            Object.keys(relatorio_financeiro_cenario[props.item.id])
                            .length
                        "
                        flat
                        >
                        <v-layout
                            row
                            wrap
                            pr-1
                            pl-1
                            pt-2
                            pb-3>
                            <v-flex xs12>
                            <v-data-table
                                show-expand
                                :items="
                                Object.values(
                                    relatorio_financeiro_cenario[props.item.id]
                                ).filter(
                                    (item) =>
                                    item.livre ||
                                    getAcessoModulo({
                                        user: user,
                                        modulo: RELATORIO_FINANCEIRO_COMPLETO,
                                    })
                                )
                                "
                                class="
                                elevation-1
                                table-exigencias table-relatorio
                                border-table-child
                                "
                                item-key="id"
                                hide-actions
                                hide-headers
                            >
                                <template v-slot:items="propsSubTopico">
                                    <tr @click="propsSubTopico.item.expanded = !propsSubTopico.item.expanded">
                                        <td>
                                        <strong>{{
                                            propsSubTopico.item.title[idioma]
                                        }}</strong>
                                        </td>
                                        <td style="width: 40%">
                                        <v-text-field
                                            v-money="
                                            renderMask(
                                                propsSubTopico.item.unidadeEsq
                                                ? propsSubTopico.item.unidadeEsq
                                                : ['', '', ''],
                                                propsSubTopico.item.unidadeDir
                                                ? propsSubTopico.item.unidadeDir
                                                : ['', '', ''],
                                                idioma
                                            )
                                            "
                                            v-if="!propsSubTopico.item.inteiro"
                                            :value="parseFloat(propsSubTopico.item.valor).toFixed(2)"
                                            readonly
                                            class="text-field-table input-disabled"
                                            color="primary"
                                            outline
                                        />
                                        <v-text-field
                                            v-money="optionsNumber.int[idioma]"
                                            v-else
                                            :value="parseFloat(propsSubTopico.item.valor).toFixed(0)"
                                            readonly
                                            class="text-field-table input-disabled"
                                            color="primary"
                                            outline
                                        />
                                        </td>
                                    </tr>
                                </template>
                                
                            </v-data-table>
                            </v-flex>
                        </v-layout>
                        </v-card>
                    </template>
                </v-data-table>
            </v-card>
            </v-flex>
            <v-flex>
                <GChart
                    ref="gchartDesvio"
                    :data="graficoComparadorGMD"
                    :options="chartOptions"
                    type="BarChart"
                />
            </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
import { mapState } from 'vuex'
import { VMoney } from 'v-money'
import {
  RELATORIO_FINANCEIRO_COMPLETO
} from '@/utils/types.js'
import { getAcessoModulo } from '@/store/auth/actions'
import { parseString } from '@/utils/vuex'

export default {
    directives: {
        money: VMoney
    },
    data: () => ({
        RELATORIO_FINANCEIRO_COMPLETO: RELATORIO_FINANCEIRO_COMPLETO,
        atributoComparador: 'IAE.DCONF'

    }),
    computed: {
        ...mapState('app', ['animal_', 'relatorio_financeiro', 'relatorio_financeiro_cenarios','headersExigenciasRelatorio', 'headersRelatorioFinanceiro', 'optionsNumber', 'idioma', 'strings', 'user']),
        chartOptions() {
            return {
                absolute: true,
                bars: "vertical", // Required for Material Bar Charts.
                hAxis: {
                format: "decimal",
                },
                height: !this.$vuetify.breakpoint.xs
                ? this.$vuetify.breakpoint.height - 220
                : this.$vuetify.breakpoint.height,
                bar: {
                groupWidth: "70%",
                },
                legend: {
                position: "none",
                },
                chart: {
                legend: {
                    position: "none",
                },
                },
                selectionMode: "multiple",
                responsive: true,
                width: !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.$vuetify.breakpoint.width - 500 : this.$vuetify.breakpoint.width,
            };
        },
        graficoComparadorGMD () {
            let chartData = [];
            let title = ["id"];
            
            let atributoComparador = this.atributoComparador
            let data = [this.relatorio_financeiro_cenarios[1][atributoComparador.split('.')[0]][atributoComparador.split('.')[1]].title[this.idioma]];
            let indices = Object.keys(this.relatorio_financeiro_cenarios).sort()
            console.log(indices)
            for (const percentagem of indices) {
                title.push(this.strings[this.idioma].x_do_gmd.format(parseInt(percentagem * 100)) + ' - ' + (parseString(this.animal_.ganho_medio_diario, this.idioma) * parseFloat(percentagem)).toFixed(2).replace('.', this.strings[this.idioma].separador_float) + 'kg');
                const relatorio_financeiro_cenario = this.relatorio_financeiro_cenarios[percentagem]
                const valor = relatorio_financeiro_cenario[atributoComparador.split('.')[0]][atributoComparador.split('.')[1]].valor
                data.push(parseFloat(valor.toFixed(2)));
            }
            chartData.push(title);
            chartData.push(data);
            return chartData;
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.montaTabelaComparacao('IAE.N', 'IAE.DCONF')
            this.headersRelatorioFinanceiro.forEach((el) => {
                for (let percentagem in this.relatorio_financeiro_cenarios) {
                    
                    try {
                        this.$set(
                            this.$refs['dTableRelatorioFinanceiro' + parseInt(percentagem * 100)][0].expanded,
                            el.id,
                            true
                        )
                    } catch (e) {

                    }
                    
                }
                
            })
        })
    },
    methods: {
        getAcessoModulo ({ user, modulo }) {
            let res = getAcessoModulo(this.$store, { user, modulo })
            return res
        },
        renderMask (esq, dir, idioma) {
            return {
                decimal: (idioma === 0 || idioma === 2) ? ',' : '.',
                thousands: (idioma === 0 || idioma === 2) ? '.' : ',',
                precision: 2,
                prefix: esq[idioma] + ' ',
                suffix: ' ' + dir[idioma]
            }
        },
        parseString (valor, idioma) {
            return this.$parseString(valor, idioma)
        },
        montaTabelaComparacao (att1, att2) {
            let table = [];
            for (const percentagem in this.relatorio_financeiro_cenarios) {
                const relatorio_financeiro_cenario = this.relatorio_financeiro_cenarios[percentagem]
                const val = relatorio_financeiro_cenario[att1.split('.')[0]][att1.split('.')[1]].valor 
                const val2 = relatorio_financeiro_cenario[att2.split('.')[0]][att2.split('.')[1]].valor

                console.log({relatorio_financeiro_cenario , percentagem, val, val2})
            }
        }
    }
}

</script>